import React from 'react';
import ReactDOM from 'react-dom/client';
//import 'bootstrap/dist/css/bootstrap.css';
import './index.css';
import App from './App';
//import reportWebVitals from './reportWebVitals';
//import Header from "./components/header";
//import About from "./components/about";
//import UrlComponent from "./components/UrlComponent";
//import Hero from "./components/Hero";
//import { getwebUri } from "./utils/interact.js";

const root = ReactDOM.createRoot(document.getElementById('root'));


//her işlemi iki kez yapmasını engellemek için document.getElementById('root')
root.render(
  //<React.StrictMode>
  <App />,


  //</React.StrictMode>,
  // document.getElementById("root")

);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
